/** v1 persists its developer options through zustand under this key: `{ state: { integrationsEnabled, ... }, version }`. */
const STORAGE_KEY = "developer-options";

const readState = (): Record<string, unknown> => {
	try {
		const parsed: unknown = JSON.parse(localStorage.getItem(STORAGE_KEY) ?? "");
		return typeof parsed === "object" &&
			parsed !== null &&
			"state" in parsed &&
			typeof parsed.state === "object" &&
			parsed.state !== null
			? (parsed.state as Record<string, unknown>)
			: {};
	} catch {
		return {};
	}
};

/** Read synchronously in `init` (KTD3): the flag never has a loading state. */
export const readIntegrationsEnabled = (): boolean =>
	readState().integrationsEnabled === true;

export const writeIntegrationsEnabled = (enabled: boolean): void => {
	localStorage.setItem(
		STORAGE_KEY,
		JSON.stringify({
			state: { ...readState(), integrationsEnabled: enabled },
			version: 0,
		}),
	);
};

/** v1's `enabled` (Developer Options): gates the Tag Input Mode section. */
export const readDeveloperEnabled = (): boolean => readState().enabled === true;

export const writeDeveloperEnabled = (enabled: boolean): void => {
	localStorage.setItem(
		STORAGE_KEY,
		JSON.stringify({ state: { ...readState(), enabled }, version: 0 }),
	);
};

export type TagInputVariant = "external" | "internal";

/** v1's Developers page choice; U7's tag input reads it. */
export const readTagInputVariant = (): TagInputVariant =>
	readState().tagInputVariant === "internal" ? "internal" : "external";

export const writeTagInputVariant = (variant: TagInputVariant): void => {
	localStorage.setItem(
		STORAGE_KEY,
		JSON.stringify({
			state: { ...readState(), tagInputVariant: variant },
			version: 0,
		}),
	);
};
